__turbopack_context__.v({
  "className": "ibm_plex_sans_1d6635fc-module__PQJBGW__className",
});
